import { Component } from '@angular/core';
import { AuthService } from "../../auth/auth.service";
import {HeaderDashboardComponent} from "./header-dashboard/header-dashboard.component";
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-dashboard-mkt',
  standalone: true,
  imports: [
    HeaderDashboardComponent,
    RouterOutlet
  ],
  templateUrl: './dashboard-mkt-sam.component.html',
  styleUrl: './dashboard-mkt-sam.component.css'
})
export class DashboardMktSamComponent {
  constructor(private authService: AuthService) {}

  logout() {
    this.authService.logout();
  }

}
